import { render } from "./AgeStructure.vue?vue&type=template&id=7b2fbc01"
import script from "./AgeStructure.vue?vue&type=script&lang=js"
export * from "./AgeStructure.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__